const swiperComponent = class extends HTMLElement {
    swiper = this.querySelector('.swiper-container');

    connectedCallback () {
        this._initSwiper();
        $(document).on('quick-buy-popover:change:end', e => this._initSwiper(e));
    }

    _initSwiper (e) {
        const swiperScrollbar = this.querySelector('.swiper-scrollbar');
        const isDesktop = window.innerWidth >= 1024;

        const swiper = new Swiper(this.swiper, {
            slidesPerView: this.swiper.getAttribute('slides-per-view') || 1,
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            scrollbar: {
                el: swiperScrollbar || null,
                draggable: true,
            },
        });

        const hoverImageIndex = this.getAttribute('hover-image-index');
        if (hoverImageIndex !== null) {
            const swiperEl = this;
            const swiperContainer = swiperEl.querySelector('.swiper-container');

            swiperContainer.addEventListener('mouseenter', () => {
                swiper.slideToLoop(parseInt(hoverImageIndex));
            });

            swiperContainer.addEventListener('mouseleave', () => {
                swiper.slideToLoop(0);
            });
        }
    }
};

window.customElements.define('swiper-component', swiperComponent);
